import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';

import { IContext } from '../../context/models/context';
import { IGalleryItem } from '../../common/models/gallery-item';
import { UrlBuilderService } from '../../common/services/url-builder.service';

@Injectable()
export class PropertyPictureService {

  constructor(
    private urlBuilder: UrlBuilderService,
    private http: HttpClient) { }

  postImage(context: IContext, files: any[]): Observable<any> {
    const propertiesUrl = this.urlBuilder.getUrl(`properties/uploadimage`);

    const body = new FormData();
    for (let i = 0; i < files.length; i++) {
      body.append('files', files[i]);    
    }

    body.append('propertyRef', String(context.PropertyRef));

    return this.http
      .post(propertiesUrl, body, { responseType: 'text' });
  }

  getImagesByProperty(propertyRef: number): Observable<IGalleryItem[]> {

    const url = this.urlBuilder.getUrl(`property/${propertyRef}/images`);
    return this.http
      .get<IGalleryItem[]>(url).pipe(
        map(images => images || undefined)
      );
  }

  deleteImage(documentKey: any): Observable<any> {
    const url = this.urlBuilder.getUrl('property/deleteimage');
    return this.http.request('delete', url, { body: documentKey });
  }

}
